import React from 'react';
import { classnames } from '../../lib';
export const EmailPill = ({ text, remove, error, selected, onClick, onBlur, onChange }) => {
    return (React.createElement(React.Fragment, null, selected ? (React.createElement("input", { className: "multi-email-input__email-pill__input", value: text, onChange: onChange, onBlur: onBlur, autoFocus: true, onKeyPress: (e) => {
            if (e.key === 'Enter')
                onBlur();
        } })) : (React.createElement("div", { className: classnames('multi-email-input__email-pill', error ? '--error' : null) },
        React.createElement("span", { className: "multi-email-input__email-pill__text", onClick: onClick }, text),
        React.createElement("span", { className: "multi-email-input__email-pill__button", onClick: remove }, "X")))));
};
//# sourceMappingURL=EmailPill.js.map